import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { PickupPlace } from './pickup-place.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
  by_location?: any;
  by_zone?: any;
}

@Injectable({
  providedIn: 'root',
})
export class PickupPlaceService {
  private apiUrl = environment.apiEndpoint + 'pickup_places';

  constructor(private http: HttpClient, private utilService: UtilService) {}

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      // let defaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getPickupPlaces(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getPickupPlace(id: string, params = null): Observable<PickupPlace> {
    const queryParams = new HttpParams({ fromObject: params });

    // If we want to update the obj
    return this.http
      .get<PickupPlace>(`${this.apiUrl}/${id}`, {
        params: queryParams,
      })
      .pipe(
        map((resp) => {
          resp.logoUrl = this.utilService.cleanItemCache(resp, 'logo');
          return resp;
        })
      );

    // return this.http.get<PickupPlace>(`${this.apiUrl}/${id}`, {
    //   params: queryParams,
    // });
  }

  // Save / Update
  savePickupPlace(
    pickupPlaceId: string,
    pickupPlace: PickupPlace,
    lang = '',
    photo = null
  ): Observable<PickupPlace> {
    let formData = new FormData();

    // Create and photo evaluated
    if (!pickupPlaceId && photo) {
      // Store form name as "file" with file data
      formData.append('file', photo, photo.name);
    }

    formData.append('lang', lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE);

    for (let key in pickupPlace) {
      // Required when using new FormData
      if (Array.isArray(pickupPlace[key])) {
        pickupPlace[key].forEach((item) => formData.append('pickup_place[' + key + '][]', item));
      } else {
        formData.append('pickup_place[' + key + ']', pickupPlace[key]);
      }
    }

    if (!pickupPlaceId) {
      return this.http.post<PickupPlace>(`${this.apiUrl}`, formData);
    } else {
      return this.http.put<PickupPlace>(`${this.apiUrl}/${pickupPlaceId}`, formData);
    }
  }

  updatePickupLogo(pickupPlaceId, photo): Observable<any> {
    const formData: FormData = new FormData();

    // Store form name as "file" with file data
    formData.append('file', photo, photo.name);
    formData.append('pickup_place[id]', pickupPlaceId);

    return this.http.put<PickupPlace>(`${this.apiUrl}/${pickupPlaceId}`, formData);
  }
}

// let formData;

// Create and photo added
/*if (!pickupPlaceId && photo) {
      console.log('HERE');

      const postData = JSON.stringify(pickupPlace);

      // Create form data
      let formData = new FormData();

      // Store form name as "file" with file data
      formData.append('file', photo, photo.name);
      formData.append('pickup_place', postData);
    } /*else {
      formData = {
        pickup_place: pickupPlace,
        lang: language || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
      };
    }*/

// console.log('pickupPlaceId: ', pickupPlaceId);
// console.log('photo: ', photo);

// for (let key in pickupPlace) {
//   formData.append('pickup_place[id]', pickupPlace[key]);
// }

// const obj = { id: pickupPlaceId };

// const req = new HttpRequest('PUT', `${this.apiUrl}/${pickupPlaceId}`, formData);
// return this.http.request(req);

// formData.append('pickup_place', JSON.stringify(body));

// formData.append('pickup_place', { id: pickupPlaceId });
// formData.append('pickup_place', JSON.stringify({ id: pickupPlaceId }));

// const obj = {
//   email: 'abc@xyz.com',
//   password: 'qwerty',
// };

// let params = new HttpParams().set('reason_status', { id: pickupPlaceId });
// let queryParams = new HttpParams({ fromObject: obj });

// let queryParams = new HttpParams({ fromObject: obj });
// let queryParams = new HttpParams().set('reason_status', 'abc');

// const queryParams = new HttpParams().set('pickup_place', JSON.stringify({ id: pickupPlaceId }));

// let queryParams = new HttpParams({ fromObject: { id: pickupPlaceId } });

// let queryParams = new HttpParams();
// queryParams=queryParams.append('sort', obj);

// const options = {
//   params: queryParams,
//   reportProgress: true,
// };

// croppedImage = {}

// let file: File = croppedImage;

// let formData: FormData = new FormData();

// formData.append('file', file, file.name);

// console.log(JSON.stringify(formData));

// formData.forEach((value, key) => {
//   console.log(key + ' ' + value);
// });
